// extracted by mini-css-extract-plugin
export var divider = "_c1-7";
export var itemsToggle = "_c1-8";
export var mergeModal = "_c1-1";
export var optionCard = "_c1-4";
export var radioGroup = "_c1-6";
export var radioOption = "_c1-0";
export var selected = "_c1-5";
export var shipmentOptions = "_c1-2";
export var tableOptions = "_c1-3";